import { isBrowser } from "./isBrowser";

export const setOneSignalExternalUserId = async (userId, retries = 3) => {
  if (
    !isBrowser() ||
    !userId ||
    typeof userId !== "string" ||
    userId.trim() === ""
  )
    return;

  const waitForOneSignal = () => {
    return new Promise((resolve) => {
      const checkOneSignal = (attempt) => {
        if (window.OneSignal && typeof window.OneSignal.login === "function") {
          resolve();
        } else if (attempt < retries) {
          setTimeout(() => checkOneSignal(attempt + 1), 500);
        } else {
          console.warn("OneSignal not available after retries");
          resolve();
        }
      };
      checkOneSignal(0);
    });
  };

  const attemptLogin = async (remainingRetries) => {
    try {
      await waitForOneSignal();
      const currentExternalId = await window.OneSignal.User.getExternalId?.();
      if (currentExternalId === userId) {
        console.log("[OneSignal] External ID already set:", userId);
        return;
      }
      await window.OneSignal.login(userId);
      console.log("OneSignal external user ID set:", userId);
    } catch (error) {
      console.error("Failed to set OneSignal external user ID:", error);
      if (remainingRetries > 0) {
        console.log(`Retrying... Attempts left: ${remainingRetries}`);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await attemptLogin(remainingRetries - 1);
      }
    }
  };

  await attemptLogin(retries);
};

export const removeOneSignalExternalUserId = async () => {
  if (!isBrowser()) return;

  const waitForOneSignal = () => {
    return new Promise((resolve) => {
      const checkOneSignal = () => {
        if (window.OneSignal && typeof window.OneSignal.logout === "function") {
          resolve();
        } else {
          setTimeout(checkOneSignal, 100);
        }
      };
      checkOneSignal();
    });
  };

  try {
    await waitForOneSignal();
    await window.OneSignal.logout();
    console.log("OneSignal external user ID removed");
  } catch (error) {
    console.error("Failed to remove OneSignal external user ID:", error);
  }
};

export const getOneSignalPlayerId = async () => {
  if (!isBrowser()) return null;

  const waitForOneSignal = () => {
    return new Promise((resolve) => {
      const checkOneSignal = () => {
        if (
          window.OneSignal &&
          typeof window.OneSignal.getUser === "function"
        ) {
          resolve();
        } else {
          setTimeout(checkOneSignal, 100);
        }
      };
      checkOneSignal();
    });
  };

  try {
    await waitForOneSignal();
    const user = await window.OneSignal.getUser();
    return user?.pushSubscription?.id || null;
  } catch (error) {
    console.error("Failed to get OneSignal subscription ID:", error);
    return null;
  }
};
